module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DSelect', {
    attrs: {
      "items": _vm.items,
      "itemsSelected": _vm.selectedItems,
      "itemsThatCantBeDeleted": _vm.itemsThatCantBeDeleted,
      "multiple": _vm.isMultiple,
      "placeholder": _vm.i18n[_vm.locale]['search'],
      "appendToBody": _vm.appendToBody,
      "calculate-position": _vm.withPopper,
      "show": _vm.show,
      "showCreateButton": _vm.showCreateButton,
      "newUserCalendarId": _vm.newUserCalendarId
    },
    on: {
      "update": _vm.setSelectedItems,
      "add": _vm.add,
      "remove": _vm.remove,
      "createNew": _vm.createNew
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-354dfe99!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectCalsIds.vue
// module id = 1524
// module chunks = 1